import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import CTLeftContent from "./CTLeftContent";
import CTRightContent from "./CTRightContent";
import cross from "../../assets/images/CT/cross1.png";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as gameAction from "../../redux/game/action";
import * as paramsAction from "../../redux/gameParams/actions";
import * as loaderAction from "../../redux/loader/action";
import { removeUser, end_Game } from "../../components/shared/utils";
import _ from "lodash";
import Socket from "../../socket/socket";

const CTGame = (props) => {
  const affilate_code = _.get(
    props,
    "paramsReducer.gameObj.affiliate_code",
    "https://shopneddy.com/?ref=4nmps8coyg"
  );
  const colours = ["blue", "yellow", "red", "green", "black", "purple"];
  const roomData = _.get(props, "gameReducer.roomObj");
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  const categoryParams = _.get(props, "paramsReducer.gameObj.category");
  const allPlayers = _.get(roomData, "users");
  const gameName = _.get(props, "gameReducer.gameName");
  const [bottomNotify, setBottomNotify] = useState(true);

  useEffect(()=>{
    props.setIsLoading(false);
  },[])
  const onEndGame = () => {
    end_Game(roomData,props)
  };

  const onTimesUp = () => {
    const { socket } = props;
    let data = {
      action: "update-status",
      roomId: roomData.id,
      tableTopName: gameName,
    };
    Socket.sendMessage(data);
  };

  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };

  return (
    <>
      <Container fluid className="d-flex flex-column justify-content-between">
        <Row className="p-4 CT-row">
          <Col sm={3} className="px-2">
            <CTLeftContent
              onEndGame={onEndGame}
              onTimesUp={onTimesUp}
              delPlayer={delPlayer}
              colours={colours}
            />
          </Col>
          <Col sm={9} className="px-2">
            <div className="CT-card h-100 teams">
              <CTRightContent colours={colours} />
            </div>
          </Col>
        </Row>
        <div className="BoardGameNotification">
          <div className="content">
            <button
              type="button"
              onClick={(e) => {
                window.open().location.href = affilate_code;
              }}
            >
              {" "}
              CLICK HERE
            </button>
            <p>to buy the Conspiracy Theory board game!</p>
          </div>
        </div>
        {bottomNotify && (
          <div className="CT-BottomNotification">
            <h2>
              Use your phone to roll the dice, answer questions, and make other
              choices when it is your turn!
            </h2>
            <button onClick={() => setBottomNotify(false)} className="btn">
              <img src={cross} />
            </button>
          </div>
        )}
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CTGame);
